module.exports = __webpack_public_path__ + "static/media/hyundai-street-selected.695fb508.svg";